export const badgeStyles = {
  margin: 'auto 0',
};

export const ellipsesStyles = theme => ({
  '&:hover': {
    backgroundColor: theme.palette.secondary.light,
  },
  backgroundColor: theme.palette.white,
  borderRadius: '100%',
  color: theme.palette.secondary.main,
  cursor: 'pointer',
  height: 24,
  marginRight: '-11px',
  marginTop: '1px',
  minWidth: 24,
  paddingBottom: 0,
  width: 24,
});

export const ellipsesActiveStyles = theme => ({
  backgroundColor: theme.palette.secondary.medium,
});

export const headerStyles = theme => ({
  '& >div.ellipses': {
    '& :hover': {
      cursor: 'pointer',
    },
    height: theme.spacing(3),
    margin: 'auto 0',
  },
  '& >h6': {
    marginRight: 'auto',
    marginTop: '2px',
  },
  alignItems: 'center',
  display: 'flex',
  marginBottom: theme.spacing(1.75),
});
